import { ArchivingTssLog }      from '@app/modules/archiving/models/archiving-tss-log.model';
import {
	archivingTssLogActions,
	IPropsUpdateArchivingTssLogState
}                               from '@app/modules/archiving/store/archiving-tss-log/archiving-tss-log.actions';
import { ArchivingTssLogState } from '@app/modules/archiving/store/archiving-tss-log/archiving-tss-log.state';
import { adapterReducer }       from '@core/store/adapter/adapter.reducer';
import { EntityAdapter }        from '@ngrx/entity';
import {
	createReducer,
	on
}                               from '@ngrx/store';
import { LoggerService }        from '@shared/services/logger.service';


export function archivingTssLogReducer(
	storeId: string,
	initialState: ArchivingTssLogState,
	archivingTssLogAdapter: EntityAdapter<ArchivingTssLog>,
	logger: LoggerService
) {
	return createReducer(
		initialState,

		...adapterReducer<ArchivingTssLog, ArchivingTssLogState>( storeId, archivingTssLogAdapter, logger ),

		// ArchivingTssLog SPECIFIC REDUCER
		on(
			archivingTssLogActions(
				storeId ).updateArchivingTssLogState,
			( state: ArchivingTssLogState, action: IPropsUpdateArchivingTssLogState ) => {
				logger?.debug( action.caller + ' | archivingTssLogReducer:updateArchivingTssLogState' );
				return {
					...state
				};
			}
		)
	);
}
